(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  /* Keeps the marquee at the speed it always had: one message used to travel
     (bar width + its own text width) in 14s, so px/s = (that) / 14. The same
     rate now carries the whole set, so the duration is the set's width over it. */
  (() => {
    const fit = () => {
      document.querySelectorAll('.announcement-marquee').forEach((marquee) => {
        const track = marquee.querySelector('.announcement-marquee__track');
        const set = track && track.firstElementChild;
        const first = set && set.firstElementChild;
        if (!set || !first) return;
        const pxPerSecond = (marquee.getBoundingClientRect().width + first.getBoundingClientRect().width) / 14;
        if (pxPerSecond > 0) track.style.setProperty('--marquee-duration', set.getBoundingClientRect().width / pxPerSecond + 's');
      });
    };
    document.addEventListener('DOMContentLoaded', fit);
    document.addEventListener('shopify:section:load', fit);
    window.addEventListener('resize', fit);
    if (document.fonts) document.fonts.ready.then(fit);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pag-brand-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const activeTab = document.querySelector('.pag-brand-header .pag-division__btn.is-active');
    const core = document.querySelector('.pag-brand-header .pag-division__core');
    if (activeTab && core) {
      const activeRight = activeTab.offsetLeft + activeTab.offsetWidth;
      if (activeRight > core.clientWidth) {
        core.scrollLeft = activeTab.offsetLeft - 8;
      }
    }

    const tabs = Array.from(document.querySelectorAll('.pag-brand-header .pag-division__btn'));
    if (!tabs.length) return;

    tabs.forEach((tab, index) => {
      tab.addEventListener('keydown', (e) => {
        let target = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') target = (index + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') target = (index - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') target = 0;
        else if (e.key === 'End') target = tabs.length - 1;

        if (target >= 0) {
          e.preventDefault();
          tabs[target].focus();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pag-brands-grid"] && !Shopify.designMode) return;
  try {
    
  /**
   * Filtering for the brands directory: the A-Z rail, the panel behind the
   * notch, and the grid they both drive.
   *
   * ONE STATE
   *
   * The letter and the categories are one selection object, read and written
   * by every control below. The alphabet lives only in the rail now — the
   * panel used to carry a second copy, and keeping two views of one axis in
   * step was the reason this was ever written as shared state. The scope
   * handling further down is left generic so a second alphabet anywhere would
   * still work rather than silently fighting the first.
   *
   * NOTHING HERE KNOWS A BRAND OR A CATEGORY
   *
   * The letters, the categories, their counts and the cards' own membership are
   * all rendered by Liquid from the section's blocks. Adding a brand, or
   * inventing a category for one, changes the page with no edit to this script.
   *
   * FACET SEMANTICS
   *
   * OR inside a group, AND between groups — the same rule Shopify's own facets
   * use, and the one people expect: two categories widens the result, a
   * category plus a letter narrows it.
   *
   * PROGRESSIVE
   *
   * The rail, the notch and the panel all ship hidden and are revealed here.
   * Without this script the page is the full sorted directory rather than a set
   * of controls that silently ignore you.
   */
  (() => {
    const OUT_MS = 200;
    const CLEAR_MS = 900;
    const PANEL_MS = 560;

    const FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const fill = (template, values) => {
      const out = Object.keys(values).reduce(
        (acc, key) => acc.split('[' + key + ']').join(String(values[key])),
        template
      );
      return values.count === 1 ? out.replace(/\bbrands\b/g, 'brand') : out;
    };

    function setup(section) {
      if (section.dataset.bfReady === 'true') return;

      const grid = section.querySelector('[data-pag-brands-list]');
      const rail = section.querySelector('[data-pag-az]');
      const divisionConsole = section.querySelector('[data-pag-division]');
      const divisionButtons = Array.from(section.querySelectorAll('[data-division]'));
      if (!grid) return;

      const cards = Array.from(grid.querySelectorAll('[data-brand-letter]'));
      if (!cards.length) return;

      // Both alphabets at once. Scoped to the section, so a second brands grid
      // on the same page keeps its own.
      const letterKeys = Array.from(section.querySelectorAll('[data-az-key]'));
      const catInputs = Array.from(section.querySelectorAll('[data-bf-cat]'));

      const status = section.querySelector('[data-az-status]');
      const panel = section.querySelector('[data-bf]');
      const notch = section.querySelector('[data-bf-open]');
      const tally = section.querySelector('[data-bf-tally]');
      // Array, not a single querySelector: the header copy of Apply carries
      // the same live "Show N brands" count as the footer one now, so both
      // have to be painted, not just whichever comes first in the DOM.
      const results = Array.from(section.querySelectorAll('[data-bf-result]'));
      const applyButtons = Array.from(section.querySelectorAll('.pag-bf__apply'));
      const clear = section.querySelector('[data-bf-clear]');

      const strings = {
        letter: rail?.dataset.azStatusTemplate || '[count] brands under [letter]',
        all: rail?.dataset.azStatusAll || 'Showing all [count] brands',
        filtered: rail?.dataset.azStatusFiltered || '[count] brands match',
        apply: rail?.dataset.azApplyLabel || 'Show [count] brands',
      };

      const state = { division: '', letter: '', cats: new Set() };
      // Category ticks are staged here and only reach the grid on Apply.
      const pending = new Set();
      let timers = [];
      let lastFocus = null;

      const clearTimers = () => {
        timers.forEach(clearTimeout);
        timers = [];
      };

      const matches = (card, cats = state.cats) => {
        if (state.division && card.dataset.brandDivision !== state.division) {
          return false;
        }
        if (state.letter) {
          const activeKey = letterKeys.find((k) => k.dataset.azKey === state.letter);
          if (activeKey && activeKey.dataset.azLetters) {
            const letters = activeKey.dataset.azLetters.split(',').map((l) => l.trim().toLowerCase());
            if (!letters.includes(card.dataset.brandLetter)) return false;
          } else if (card.dataset.brandLetter !== state.letter) {
            return false;
          }
        }
        if (!cats.size) return true;
        const own = (card.dataset.brandCategories || '').split(' ').filter(Boolean);
        return own.some((one) => cats.has(one));
      };

      function paintControls(shown) {
        divisionButtons.forEach((btn) => {
          const on = (btn.dataset.division || '') === state.division;
          btn.setAttribute('aria-selected', on ? 'true' : 'false');
          btn.classList.toggle('is-active', on);
          btn.tabIndex = on ? 0 : -1;
        });

        letterKeys.forEach((key) => {
          const on = key.dataset.azKey === state.letter;
          key.setAttribute('aria-pressed', on ? 'true' : 'false');
          key.tabIndex = on ? 0 : -1;

          const k = key.dataset.azKey;
          if (k) {
            const letters = key.dataset.azLetters
              ? key.dataset.azLetters.split(',').map((l) => l.trim().toLowerCase())
              : [k];
            const hasMatches = cards.some((card) => {
              if (state.division && card.dataset.brandDivision !== state.division) return false;
              return letters.includes(card.dataset.brandLetter);
            });
            key.classList.toggle('is-disabled', !hasMatches);
            key.disabled = !hasMatches;
          }
        });

        // Each alphabet needs a tab stop even with nothing pressed, or the
        // toolbar becomes unreachable by keyboard.
        [rail, panel].forEach((scope) => {
          if (!scope) return;
          const own = letterKeys.filter((key) => scope.contains(key));
          if (own.length && !own.some((key) => key.tabIndex === 0)) {
            const firstEnabled = own.find((k) => !k.disabled) || own[0];
            firstEnabled.tabIndex = 0;
          }
        });

        catInputs.forEach((input) => {
          input.checked = pending.has(input.dataset.bfCat);
        });

        const active = (state.letter ? 1 : 0) + state.cats.size;
        if (tally) {
          tally.textContent = String(active);
          tally.hidden = active === 0;
        }
        if (notch) notch.dataset.bfActive = active ? 'true' : 'false';
        if (clear) clear.disabled = active === 0 && pending.size === 0;
        const dirty = pending.size !== state.cats.size || [...pending].some((one) => !state.cats.has(one));
        const staged = cards.filter((card) => matches(card, pending)).length;
        results.forEach((el) => {
          el.textContent = fill(strings.apply, { count: staged });
        });
        // Nothing to commit, nothing to click — same rule as the product
        // facets: Apply only shows once a letter or category is actually set.
        applyButtons.forEach((btn) => {
          btn.hidden = !dirty;
        });

        if (status) {
          let template = strings.all;
          if (state.cats.size) template = strings.filtered;
          else if (state.letter) template = strings.letter;

          const activeKey = letterKeys.find((k) => k.dataset.azKey === state.letter);
          const activeLabel = activeKey
            ? (activeKey.childNodes[0]?.textContent?.trim() || activeKey.textContent.trim())
            : state.letter.toUpperCase();

          status.textContent = fill(template, {
            count: shown,
            letter: activeLabel,
          });
        }
      }

      function commit(arrive) {
        let shown = 0;
        cards.forEach((card) => {
          const on = matches(card);
          card.hidden = !on;
          if (on) {
            card.style.setProperty('--az-i', String(shown++));
            card.style.opacity = '1';
            // removeProperty, not transform:'none' — the phase rules and the
            // pag-az-arrive keyframes drive transform during a transition; at
            // rest the wrapper should own no inline value at all.
            card.style.removeProperty('transform');
          }
        });

        // Release section anim state so pag-overrides.css doesn't hold unrevealed cards at opacity 0
        if (section.dataset.anim && section.dataset.anim !== 'done') {
          section.dataset.anim = 'done';
        }

        // Only when the reader asked for it. On first paint the section's own
        // reveal is already staggering these cards from an inline opacity, and
        // a CSS animation outranks an inline style while it runs — an arrival
        // here would seize them mid-reveal and drop them back.
        if (arrive) {
          grid.dataset.azPhase = 'in';
          timers.push(
            window.setTimeout(() => {
              delete grid.dataset.azPhase;
            }, CLEAR_MS)
          );
        }

        paintControls(shown);
      }

      function apply({ animate = true } = {}) {
        clearTimers();
        syncUrl();

        if (!animate || reduced()) {
          commit(false);
          return;
        }

        grid.dataset.azPhase = 'out';
        timers.push(window.setTimeout(() => commit(true), OUT_MS));
      }

      function syncUrl() {
        const url = new URL(window.location.href);
        if (state.division) url.searchParams.set('division', state.division);
        else url.searchParams.delete('division');

        if (state.letter) url.searchParams.set('letter', state.letter);
        else url.searchParams.delete('letter');

        if (state.cats.size) url.searchParams.set('category', Array.from(state.cats).join(','));
        else url.searchParams.delete('category');

        // replaceState, not pushState: filtering a directory is not a
        // destination, and stacking every keystroke would turn the back button
        // into an undo log.
        window.history.replaceState({}, '', url);
      }

      /* ---- the panel ---- */

      function openPanel() {
        if (!panel) return;
        lastFocus = document.activeElement;
        panel.hidden = false;
        notch?.setAttribute('aria-expanded', 'true');
        document.documentElement.style.setProperty('overflow', 'hidden');
        // A frame between unhiding and animating, or the browser has nothing to
        // transition from and the drawer simply appears.
        requestAnimationFrame(() => {
          panel.dataset.bfState = 'open';
        });
        const first = panel.querySelector(FOCUSABLE);
        window.setTimeout(() => first?.focus(), reduced() ? 0 : 120);
      }

      function closePanel() {
        if (!panel || panel.hidden) return;
        delete panel.dataset.bfState;
        notch?.setAttribute('aria-expanded', 'false');
        document.documentElement.style.removeProperty('overflow');
        window.setTimeout(
          () => {
            panel.hidden = true;
          },
          reduced() ? 0 : PANEL_MS
        );
        lastFocus?.focus();
      }

      const sheet = panel?.querySelector('.pag-bf__panel');
      const scrim = panel?.querySelector('.pag-bf__scrim');

      // >=990px: the panel docks as an always-visible sidebar (CSS handles the
      // layout switch, see .pag-brands-body above). It stops being a modal
      // dialog at that width, so the ARIA that makes it one has to come off,
      // and any open/closed state left over from a narrower viewport has to
      // be cleared rather than sit there invisibly until the viewport crosses
      // back down. Same fix as snippets/pag-facets-script.liquid.
      if (panel && sheet) {
        const DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');
        const syncDesktopMode = (isDesktop) => {
          if (isDesktop) {
            sheet.removeAttribute('role');
            sheet.removeAttribute('aria-modal');
            if (panel.dataset.bfState === 'open') delete panel.dataset.bfState;
            notch?.setAttribute('aria-expanded', 'false');
            document.documentElement.style.removeProperty('overflow');
          } else {
            sheet.setAttribute('role', 'dialog');
            sheet.setAttribute('aria-modal', 'true');
          }
        };
        syncDesktopMode(DESKTOP_QUERY.matches);
        DESKTOP_QUERY.addEventListener('change', (event) => syncDesktopMode(event.matches));
      }

      notch?.addEventListener('click', () => {
        if (panel?.classList.contains('pag-bf--dragging')) return;
        openPanel();
      });

      // Real-time drag gesture physics for opening and closing
      if (notch && panel && sheet) {
        let startX = 0;
        let startY = 0;
        let currentX = 0;
        let isDragging = false;
        let isFromNotch = false;
        let isLocked = false;
        let startTime = 0;

        const onPointerDown = (e) => {
          if (e.button !== 0 && e.pointerType === 'mouse') return;
          const target = e.target;
          const isInteractive = target.closest('input, button, a, select, textarea, label, [data-bf-range]');
          const isHeaderOrHandle = target.closest('.pag-bf__head, .pag-bf__drag-handle');
          isFromNotch = notch.contains(target);

          if (!isFromNotch && isInteractive && !isHeaderOrHandle) return;

          startX = e.clientX;
          startY = e.clientY;
          currentX = startX;
          startTime = Date.now();
          isDragging = false;
          isLocked = false;

          target.setPointerCapture?.(e.pointerId);

          const onPointerMove = (moveEvent) => {
            const dx = moveEvent.clientX - startX;
            const dy = moveEvent.clientY - startY;

            if (!isLocked) {
              if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 6 && !isFromNotch) {
                isLocked = true;
                return;
              }
              if (Math.abs(dx) > 6) {
                isLocked = true;
                isDragging = true;
                panel.classList.add('pag-bf--dragging');
                if (isFromNotch) {
                  panel.hidden = false;
                  document.documentElement.style.setProperty('overflow', 'hidden');
                }
              }
            }

            if (!isDragging) return;
            moveEvent.preventDefault();
            currentX = moveEvent.clientX;

            const width = sheet.offsetWidth || 380;
            if (isFromNotch) {
              const pulled = Math.max(0, -dx);
              const progress = Math.min(1, pulled / width);
              const translatePct = (1 - progress) * 100;
              sheet.style.transform = `translateX(${translatePct}%)`;
              if (scrim) scrim.style.opacity = String(progress);
            } else {
              const pushed = Math.max(0, dx);
              const progress = Math.min(1, pushed / width);
              const translatePct = progress * 100;
              sheet.style.transform = `translateX(${translatePct}%)`;
              if (scrim) scrim.style.opacity = String(1 - progress);
            }
          };

          const onPointerUp = (upEvent) => {
            try {
              target.releasePointerCapture?.(upEvent.pointerId);
            } catch (err) {}

            window.removeEventListener('pointermove', onPointerMove);
            window.removeEventListener('pointerup', onPointerUp);
            window.removeEventListener('pointercancel', onPointerUp);

            if (!isDragging) return;

            panel.classList.remove('pag-bf--dragging');
            sheet.style.transform = '';
            if (scrim) scrim.style.opacity = '';

            const dx = currentX - startX;
            const duration = Math.max(1, Date.now() - startTime);
            const velocity = dx / duration;
            const width = sheet.offsetWidth || 380;

            if (isFromNotch) {
              const pulled = -dx;
              const progress = pulled / width;
              if (progress > 0.25 || velocity < -0.28) {
                openPanel();
              } else {
                closePanel();
              }
            } else {
              const pushed = dx;
              const progress = pushed / width;
              if (progress > 0.25 || velocity > 0.28) {
                closePanel();
              } else {
                openPanel();
              }
            }
          };

          window.addEventListener('pointermove', onPointerMove, { passive: false });
          window.addEventListener('pointerup', onPointerUp, { once: true });
          window.addEventListener('pointercancel', onPointerUp, { once: true });
        };

        notch.addEventListener('pointerdown', onPointerDown);
        panel.addEventListener('pointerdown', onPointerDown);
      }

      panel?.addEventListener('click', (event) => {
        if (panel?.classList.contains('pag-bf--dragging')) return;
        if (event.target.closest('[data-bf-dismiss]')) {
          if (event.target.closest('.pag-bf__apply')) {
            state.cats = new Set(pending);
            apply();
          }
          closePanel();
          // Filtering here is already live (every checkbox commits its own
          // change as it's ticked) — dismissing the panel doesn't apply
          // anything new, it just reveals a grid that may now be much
          // shorter than it was. Without this, a reader who scrolled deep
          // into the full list before filtering lands back on a blank
          // stretch of page below the new, shorter grid. Only when a filter
          // is actually active, so closing an untouched panel never scrolls.
          if (state.letter || state.cats.size) {
            grid?.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
          }
        }
      });

      panel?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closePanel();
          return;
        }
        if (event.key !== 'Tab') return;

        // A modal that lets focus walk out behind the scrim is not modal.
        const focusables = Array.from(panel.querySelectorAll(FOCUSABLE)).filter(
          (node) => node.offsetParent !== null
        );
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      /* ---- the controls ---- */

      divisionConsole?.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-division]');
        if (!btn) return;
        const targetDiv = btn.dataset.division || '';
        if (state.division === targetDiv) return;
        state.division = targetDiv;

        // If current letter filter has zero brands under the new division, clear letter
        if (state.letter) {
          const activeKey = letterKeys.find((k) => k.dataset.azKey === state.letter);
          const letters = activeKey && activeKey.dataset.azLetters
            ? activeKey.dataset.azLetters.split(',').map((l) => l.trim().toLowerCase())
            : [state.letter];
          const hasMatches = cards.some((card) => {
            if (state.division && card.dataset.brandDivision !== state.division) return false;
            return letters.includes(card.dataset.brandLetter);
          });
          if (!hasMatches) {
            state.letter = '';
          }
        }

        apply();
      });

      divisionConsole?.addEventListener('keydown', (event) => {
        const btn = event.target.closest('[data-division]');
        if (!btn) return;
        const index = divisionButtons.indexOf(btn);
        if (index < 0) return;

        let next = -1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % divisionButtons.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + divisionButtons.length) % divisionButtons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = divisionButtons.length - 1;
        else return;

        event.preventDefault();
        divisionButtons[next].focus();
        divisionButtons[next].click();
      });

      section.addEventListener('click', (event) => {
        const key = event.target.closest('[data-az-key]');
        if (!key || !section.contains(key)) return;
        // Pressing the live letter clears it. Without this the only way back to
        // the full list is to find "All", which may be scrolled out of sight.
        state.letter = key.dataset.azKey === state.letter ? '' : key.dataset.azKey;
        apply();
      });

      section.addEventListener('change', (event) => {
        const input = event.target.closest('[data-bf-cat]');
        if (!input) return;
        if (input.checked) pending.add(input.dataset.bfCat);
        else pending.delete(input.dataset.bfCat);
        paintControls(cards.filter((card) => !card.hidden).length);
      });

      clear?.addEventListener('click', () => {
        state.letter = '';
        state.cats.clear();
        pending.clear();
        apply();
      });

      section.addEventListener('keydown', (event) => {
        const key = event.target.closest('[data-az-key]');
        if (!key) return;

        // Arrow keys move within the alphabet the key belongs to, never across
        // into the other one.
        const scope = panel && panel.contains(key) ? panel : rail;
        const group = letterKeys.filter((one) => scope && scope.contains(one));
        const index = group.indexOf(key);
        if (index < 0) return;

        let next = -1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % group.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + group.length) % group.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = group.length - 1;
        else return;

        event.preventDefault();
        group[next].tabIndex = 0;
        key.tabIndex = -1;
        group[next].focus();
        group[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });

      /* ---- boot ---- */

      const params = new URL(window.location.href).searchParams;

      const divParam = (params.get('division') || '').toLowerCase().trim();
      if (divParam === 'pro-audio' || divParam === 'mi') {
        state.division = divParam;
      }

      const rawLetterParam = (params.get('letter') || '')
        .toLowerCase()
        .replace(/[\u2013\u2014]/g, '-')
        .trim();
      if (rawLetterParam) {
        const directMatch = letterKeys.find((key) => key.dataset.azKey === rawLetterParam);
        if (directMatch) {
          state.letter = directMatch.dataset.azKey;
        } else {
          const rangeMatch = letterKeys.find((key) => {
            const letters = (key.dataset.azLetters || '').split(',').map((l) => l.trim().toLowerCase());
            return letters.includes(rawLetterParam);
          });
          if (rangeMatch) {
            state.letter = rangeMatch.dataset.azKey;
          }
        }
      }

      const known = new Set(catInputs.map((input) => input.dataset.bfCat));
      (params.get('category') || '')
        .split(',')
        .map((one) => one.trim().toLowerCase())
        .filter((one) => known.has(one))
        .forEach((one) => state.cats.add(one));
      state.cats.forEach((one) => pending.add(one));

      // Reveal already loaded/cached images without skeleton delay
      grid.querySelectorAll('.pag-brands-card-media img').forEach((img) => {
        if (img.complete && img.naturalWidth > 0) {
          img.classList.add('is-loaded');
          img.parentElement?.classList.add('has-loaded');
        }
      });

      if (rail) rail.hidden = false;
      if (notch && (letterKeys.length || catInputs.length)) notch.hidden = false;
      section.dataset.bfReady = 'true';

      apply({ animate: false });
    }

    const boot = () =>
      document
        .querySelectorAll('.pag-brands-grid-section, .pag-brands-grid')
        .forEach((node) => setup(node.closest('.shopify-section') || node));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    // The theme editor swaps a section's markup without reloading the page.
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pag-newsletter-modal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pag-newsletter-modal')) {
    customElements.define('pag-newsletter-modal', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.id_ = this.dataset.modalId;
        this.addEventListener('click', (e) => {
          if (e.target === this.dialog || e.target.closest('[data-pag-close]')) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          if (!this.finished) PagModalGate.dismissed(this.id_);
        });
        const form = this.querySelector('form');
        form?.addEventListener('submit', (e) => this.subscribe(e, form));
        this.querySelector('[data-pag-signin]')?.addEventListener('click', () => PagModalGate.dismissed(this.id_));
        if (window.Shopify && Shopify.designMode) {
          if (this.dataset.preview === 'true') this.open();
          return;
        }
        const cfg = {
          newsletter: true,
          minViews: +this.dataset.minViews, delay: +this.dataset.delay, scrollPct: +this.dataset.scroll,
          cooldownDays: +this.dataset.cooldown, globalGapDays: +this.dataset.gap, maxShows: +this.dataset.max,
        };
        const run = () => {
          if (!PagModalGate.eligible(this.id_, cfg)) return;
          PagModalGate.schedule(cfg, () => { PagModalGate.shown(this.id_); this.open(); });
        };
        window.PagModalGate ? run() : addEventListener('DOMContentLoaded', run);
      }
      open() { if (!this.dialog.open) this.dialog.showModal(); }
      async subscribe(e, form) {
        e.preventDefault();
        const err = this.querySelector('.pag-dm__error');
        const email = form.querySelector('input[type=email]');
        err.hidden = true;
        if (!email.validity.valid || !email.value) { err.textContent = this.dataset.invalid; err.hidden = false; return; }
        try {
          const res = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
          if (!res.ok || !/customer_posted=true/.test(res.url)) throw new Error('failed');
          this.finished = true;
          PagModalGate.done('newsletter');
          this.querySelector('.pag-dm__form').hidden = true;
          this.querySelector('.pag-dm__done').hidden = false;
          setTimeout(() => this.dialog.open && this.dialog.close(), 5000);
        } catch {
          HTMLFormElement.prototype.submit.call(form);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pag-signin-modal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pag-signin-modal')) {
    customElements.define('pag-signin-modal', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.addEventListener('click', (e) => {
          if (e.target === this.dialog || e.target.closest('[data-pag-close]')) this.close();
        });
        this.dialog.addEventListener('close', () => this.dispatchEvent(new CustomEvent('pag-signin:closed', { bubbles: true })));
        if (this.dataset.preview === 'true' && window.Shopify && Shopify.designMode) this.open();
      }
      open() {
        if (!this.dialog.open) this.dialog.showModal();
        this.dispatchEvent(new CustomEvent('pag-signin:opened', { bubbles: true }));
      }
      close() { this.dialog.close(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pag-welcome-modal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pag-welcome-modal')) {
    customElements.define('pag-welcome-modal', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.id_ = this.dataset.modalId;
        this.addEventListener('click', (e) => {
          if (e.target === this.dialog || e.target.closest('[data-pag-close]')) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          if (!this.finished) PagModalGate.dismissed(this.id_);
        });
        const form = this.querySelector('form');
        form?.addEventListener('submit', (e) => this.subscribe(e, form));
        this.querySelector('[data-pag-signin]')?.addEventListener('click', () => PagModalGate.dismissed(this.id_));
        if (window.Shopify && Shopify.designMode) {
          if (this.dataset.preview === 'true') this.open();
          return;
        }
        const cfg = {
          newsletter: true,
          minViews: +this.dataset.minViews, delay: +this.dataset.delay, scrollPct: +this.dataset.scroll,
          cooldownDays: +this.dataset.cooldown, globalGapDays: +this.dataset.gap, maxShows: +this.dataset.max,
        };
        const run = () => {
          if (!PagModalGate.eligible(this.id_, cfg)) return;
          PagModalGate.schedule(cfg, () => { PagModalGate.shown(this.id_); this.open(); });
        };
        window.PagModalGate ? run() : addEventListener('DOMContentLoaded', run);
      }
      open() { if (!this.dialog.open) this.dialog.showModal(); }
      async subscribe(e, form) {
        e.preventDefault();
        const err = this.querySelector('.pag-dm__error');
        const email = form.querySelector('input[type=email]');
        err.hidden = true;
        if (!email.validity.valid || !email.value) { err.textContent = this.dataset.invalid; err.hidden = false; return; }
        try {
          const res = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
          if (!res.ok || !/customer_posted=true/.test(res.url)) throw new Error('failed');
          this.finished = true;
          PagModalGate.done('newsletter');
          this.querySelector('.pag-dm__form').hidden = true;
          this.querySelector('.pag-dm__done').hidden = false;
          setTimeout(() => this.dialog.open && this.dialog.close(), 5000);
        } catch {
          HTMLFormElement.prototype.submit.call(form);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
